import React from 'react';
import './LoadingDots.css';

const LoadingDots = ({ variant }) => {
  const className = `loading-dots${variant ? ` loading-dots--${variant}` : ''}`;
  return (
    <span className={className}>
      <span className="dot">.</span>
      <span className="dot">.</span>
      <span className="dot">.</span>
    </span>
  );
};

export default LoadingDots;
